import { makeStyles } from '@material-ui/styles'

import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  label: {
    fontSize: spacing(16),
    color: Theme.Colors.Grayscale.Eighty,
    fontFamily: Theme.Typography.FontFamily.Roboto,
  },
  required: {
    color: Theme.Colors.Red.Base,
    marginLeft: spacing(4),
  },
  errorMessage: {
    color: `${palette.error.main} !important`,
    margin: 0,
    fontSize: spacing(10.5),
    fontFamily: 'Roboto',
    height: spacing(10),
    display: 'flex !important',
  },
  rating: {
    fontSize: '3.0rem',
    opacity: '1 !important',
  },
}))
